import { render, staticRenderFns } from "./ThgAdvertisment.vue?vue&type=template&id=22c83b2e&scoped=true&"
import script from "./ThgAdvertisment.vue?vue&type=script&lang=ts&"
export * from "./ThgAdvertisment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c83b2e",
  null
  
)

export default component.exports